export default __webpack_public_path__ + "static/media/cloud-upload-outline.9fcadb29.svg";